export default "__VITE_ASSET__CKeJRVV___"